<template>
    <div
        class="aup-public-profile-user-footer d-flex flex-column align-items-center justify-content-center"
    >
        <!-- REPORT USER ICON -->
        <!-- <div class="aup-public-profile-user-footer__report-icon-container" v-if="!isSelfProfile">
            <div
                role="button"
                class="aup-public-profile-user-footer__report-button d-inline-block"
                @click="openReportModal()"
            >
                <p class="t-micro t-heavy t-micro--regular p-1 text-white mb-0">Report Profile</p>
            </div>
        </div> -->

        <div
            v-if="backgroundImage"
            class="aup-public-profile-user-footer__bg aup-public-profile-user-footer__bg--image"
            :style="{'background-image': respMediaBackgroundImage(backgroundImage.ppd_imageurl, backgroundImage.ppd_zestyguid, 1500)}"
            role="img"
            :aria-label="`Cover photo of ${name}`"
        ></div>
        <div v-else class="aup-public-profile-user-footer__bg"></div>
        <div
            class="aup-public-profile-user-footer__avatar"
            :style="{'background-image' : respMediaBackgroundImage(avatar.ppd_imageurl, avatar.ppd_zestyguid, 400, 400) }"
            role="img"
            :aria-label="`Profile photo of ${name}`"
        ></div>
        <h4 class="aup-public-profile-user-footer__name d-flex align-items-center t-heavy h1 t-shadow text-white mb-0 my-3">error:call:4</h4>
        <BaseLikeButton
            :height="w > 768 ? 85 : 24"
            :width="w > 768 ? 85 : 24"
            :isSelf="isSelfProfile"
            :likedContent="profileGUID"
            :likeType="'profile'"
            textPlacement="right"
            :profileView="true"
            :loggedIn="loggedIn"
			:showCount="true"
			:offsetTooltip="true"
        />
		<!-- REPORT USER ICON -->
		<div class="aup-public-profile-user-footer__report-icon-container" v-if="!isSelfProfile && loggedIn">
			<div
				role="button"
				class="aup-public-profile-user-footer__report-button d-flex"
				@click="openReportModal()"
			>
				<IconReportDots />
				<div class="aup-public-profile-user-footer__tooltip__container d-inline-flex" v-if="!isSelfProfile">
					<p class="aup-public-profile-user-footer__tooltip t-micro t-heavy t-micro--regular">Report Profile</p>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
import { calcRespImageURLMixin } from '@/mixins/mixins.js';

export default {
	name: 'LikeProfile',
	mixins: [ calcRespImageURLMixin ],
	data() {
		return {
			w: window.innerWidth
		}
	},
    props: {
        avatar: {
            type: Object,
            default: null,
        },
        backgroundImage: {
            type: Object,
            default: null,
        },
        isSelfProfile: {
            type: Boolean,
            default: false,
        },
        profileGUID: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        loggedIn: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        openReportModal() {
            this.$emit('show-report-modal', true);
        },
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/all';
.aup-public-profile-user-footer {
    min-height: 60vh;
    width: 100vw;
    position: relative;
	// dl: other sections use py-5, which equates to 40px
    padding: 40px 0;
	@include media-breakpoint-down(sm) {
		padding: 20px 0;
		min-height: 40vh;
	}
    &__bg {
        z-index: -1;
        height: 120%;
        width: 120%;
        position: absolute;
        top: -10%;
        left: -10%;
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: $sony-black;
        &--image {
            filter: blur(20px) brightness(80%);
        }
	}
	&__name {
		@include media-breakpoint-down(sm) {
			font-size:2.25rem!important;
		}
		&::after {
			content: "Beta";
			background-color: #E75300;
			color: white;
			border-radius: 2px;
			font-size: 10px;
			font-family: "SSTProRoman", Arial, Helvetica, sans-serif;
			padding: 2px 4px 3px;
			margin-left: 5px;
		}
	}
	&__report-icon-container {
        z-index: map-get($zindices, fixed);
		position: absolute;
		bottom: 1rem;
    }
    &__report-button:hover {
        &
            .aup-public-profile-user-footer__tooltip__container
            .aup-public-profile-user-footer__tooltip {
            opacity: 1;
        }
		// dl : commenting out per design but leaving in case design changes mind
		// .icon__report-flag {
		// 	fill: $primary;
		// }
	}
	// dl: TODO make this into component
    &__report-button {
		cursor: pointer;
		background-color: rgba($sony-black, 0.8);
		padding: 0.5rem 0.3rem;
		// position: relative;
		// top: 50%;
		// transform: translateY(-50%);
		&--mobile {
			cursor: pointer;
			position: relative;
		}
    }
	&__tooltip {
        opacity: 0;
        transition: opacity 0.3s ease-in;
        bottom: 75px;
        // margin-left: -0.2rem;
        min-width: 100px;
        border-radius: 2px;
        background-color: $sony-white;
        color: $sony-black;
        text-align: center;
		padding: 0.25rem;
        &:before {
            content: '';
            position: absolute;
            border-style: solid;
            display: block;
            margin-top: 25px;
            margin-left: 41px;
            border-color: $sony-white transparent;
			border-width: 5px 5px 0;
        }
        &__container {
            z-index: map-get($zindices, fixed);
            position: absolute;
            bottom: 20px;
			left: 50%;
			transform: translate(-50%);
        }
    }
    &__avatar {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        width: 200px;
        height: 200px;
        border: 5px solid $white;
        border-radius: 50%;
        @include media-breakpoint-down(md) {
            height: 150px;
            width: 150px;
        }
		@include media-breakpoint-down(sm) {
			height: 100px;
			width: 100px;
		}
    }
    &__button {
        cursor: pointer;
        @include media-breakpoint-down(md) {
            height: 70px;
            width: 70px;
        }
        &--active {
            cursor: default;
            path {
                fill: $primary;
            }
            @include media-breakpoint-down(md) {
                margin: 0 auto;
            }
        }
    }
}
</style>
